export default __webpack_public_path__ + "static/media/payment-box-icon-03.6cbc7ebf.png";